import styles from './CategoryProducts.module.scss';
import React, { useEffect, useState } from 'react';
import ProductsCarousel from '../../../Products/ProductsCarousel';
import ButtonAddToWishlistAllProducts from '../ButtonAddToWishlistAllProducts/ButtonAddToWishlistAllProducts';
import { mergeArrays } from '../../../../functions';

const CategoryProducts = ({ api = properties, properties, animationData }) => {
  const productsList = mergeArrays(properties?.products, properties?.productsBorder);

  return (
    !!productsList && (
      <div
        className={styles.cardContainer}
        data-aos={animationData?.animation}
        data-aos-delay={animationData?.animationDelay}
        data-aos-duration={animationData?.animationDuration}
        data-aos-easing={animationData?.animationEasing}
        data-aos-anchor-placement={animationData?.animationAnchor}
      >
        {!api?.attributes?.wishlistoff && <ButtonAddToWishlistAllProducts productsList={productsList} />}
        <ProductsCarousel productsList={productsList} type="productSubcategory" />
      </div>
    )
  );
};
export default CategoryProducts;
